module.exports = __webpack_public_path__ + "static/media/how-it-work.750e0d1a.jpg";